import React from 'react';
import styled from '@emotion/styled';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
`

const Title = styled.h1`
  color: #4CAF50;
  margin-bottom: 2rem;
`

const Section = styled.section`
  margin-bottom: 2rem;
`

function Terms() {
  return (
    <Container>
      <Title>Terms of Service</Title>
      
      <Section>
        <h2>Acceptance of Terms</h2>
        <p>
          By accessing and using Farmers Market Finder, you accept and agree to be bound by the terms 
          and provision of this agreement.
        </p>
      </Section>

      <Section>
        <h2>Use License</h2>
        <p>
          Permission is granted to temporarily access the Farmers Market Finder for personal, 
          non-commercial use. This is the grant of a license, not a transfer of title.
        </p>
      </Section>

      <Section>
        <h2>Disclaimer</h2>
        <p>
          The materials on Farmers Market Finder are provided on an 'as is' basis. We make no 
          warranties, expressed or implied, and hereby disclaim and negate all other warranties 
          including, without limitation, implied warranties or conditions of merchantability, 
          fitness for a particular purpose, or non-infringement of intellectual property or 
          other violation of rights.
        </p>
      </Section>

      <Section>
        <h2>Limitations</h2>
        <p>
          In no event shall Farmers Market Finder or its suppliers be liable for any damages 
          (including, without limitation, damages for loss of data or profit, or due to business 
          interruption) arising out of the use or inability to use the materials on the website.
        </p>
      </Section>

      <Section>
        <h2>Accuracy of Materials</h2>
        <p>
          The materials appearing on Farmers Market Finder could include technical, typographical, 
          or photographic errors. We do not warrant that any of the materials on the website are 
          accurate, complete, or current.
        </p>
      </Section>
    </Container>
  );
}

export default Terms;
